import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
// import { ShapeOptions , CircleProgressComponent} from 'angular2-progressbar';

import { HttpClientService, CookieManagerService ,ErrorManagerService} from '../../../shared/';
import { Paper, PaperReport } from '../../model';
import { CookieNames, BasicRoutes, QustionStatus, CircleUIOptions, ApiEndpoints } from '../../constant';
import { environment } from '../../../';

@Component({
  selector: 'app-report-papers',
  templateUrl: '../views/report-papers.component.html',
  styleUrls: ['../../../css/report-papers.component.css','../../../css/paper-sets.component.css']
})
export class ReportPapersComponent implements OnInit {

  // @ViewChild(CircleProgressComponent) circleComp: CircleProgressComponent;

  paperPartsUrl:string = BasicRoutes.clientPaperParts;
  setid : string;
  papers : Array<Paper> = [];
  papersReport: PaperReport;
  statics : any=[];
  qustionStatus : Object = QustionStatus;
  paperSettitle: Object;
  public totalReport: number;

  constructor(private route: ActivatedRoute,
    private httpClientService: HttpClientService,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService,
    private router: Router,
    public toastr: ToastsManager) { }

  // private circleOptions: ShapeOptions = {
  //     color: CircleUIOptions.fillColor,
  //     trailColor: CircleUIOptions.trailColor,
  //     trailWidth: CircleUIOptions.trailWidth,
  //     duration: CircleUIOptions.duration,
  //     easing: CircleUIOptions.easing,
  //     strokeWidth: CircleUIOptions.strokeWidth,
  //     from: { color: CircleUIOptions.fillColor, a: 0 },
  //     to: { color: CircleUIOptions.baseColor, a: 1 },
  //     step: function(state: any, circle: any) {
  //       circle.path.setAttribute(CircleUIOptions.theme, CircleUIOptions.fillColor);
  //     }
  //   };

  showSuccess() {
    //this.toastr.success('School app success', 'Success!');
  }

  ngOnInit() {
    
    this.route.params.forEach((params: Params) => {
        this.setid = params['setid'];
        this.cookieManagerService.setCookie(CookieNames.paperSetKey, this.setid, false, 1);
    });
    this.paperSettitle = this.cookieManagerService.getCookie(CookieNames.paperSettitle, false);
    this.getPapersInSet();
    this.getPapers();
    window.scrollTo(0, 0);
  }

  setAllMakes() {
    let total = this.papersReport['totalReport'];
    // this.circleComp.animate(total/100);
    this.totalReport =Math.round(total);
  }

  getPapersInSet(){
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaperReportStatics, {
      [ApiEndpoints.setid] : this.setid
    }),  this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      this.papersReport= response;
      this.setAllMakes();
    }, error => {
      // this.ErrorManagerService.setError(error);
    }); 
  }

  getPapers(){

    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getPaperReports, {
      [ApiEndpoints.setid] : this.setid
    }),this.cookieManagerService.getCookie(CookieNames.paperSetKey, false)).subscribe(response => {
      this.papers = response;
    }, error => {
      this.ErrorManagerService.setError(error);
    });
  }
  
  paperSetRouter(paper){
    this.router.navigate(['/home/reports/papers/'+paper._id+'/parts']);
    this.cookieManagerService.setCookie(CookieNames.paperTitle, paper.title, false, 1);
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/report/components/report-papers.component.ts